import React, { useState, useEffect } from "react";
import { Box, Typography, useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/material/styles";

import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import img1 from "../../assets/landing/MainSection/img-01.jpg";
import img2 from "../../assets/landing/MainSection/img-02.jpg";
import img3 from "../../assets/landing/MainSection/img-03.jpg";
import img4 from "../../assets/landing/MainSection/img-04.jpg";
import img5 from "../../assets/landing/MainSection/img-05.jpg";

const images = [img1, img2, img3, img4, img5];

const HeroSection = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const [bgIndex, setBgIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setBgIndex((prevIndex) => (prevIndex + 1) % images.length);
    }, 6000); // every 6 seconds

    return () => clearInterval(interval);
  }, []);

  return (
    <>
      <Box
        sx={{
          position: "relative",
          width: "100%",
          height: "100vh",
          overflow: "hidden",
          textAlign: "center",
        }}
      >
        {/* Background Image with Zoom Animation */}
        <Box
          component="div"
          sx={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundImage: `url(${images[bgIndex]})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            zIndex: -2,
            animation: "zoomIn 6s ease-in-out infinite",
          }}
        />

        <Box
          sx={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0, 0, 0, 0.5)", // Adjust opacity here
            zIndex: -1, // between image and content
          }}
        />
        {/* Keyframes for zoom effect */}
        <style>
          {`
          @keyframes zoomIn {
            0% {
              transform: scale(1);
            }
            100% {
              transform: scale(1.1);
            }
          }
        `}
        </style>

        {/* Content - Centered */}
        <Box
          sx={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            textAlign: "center",
            px: 2,
          }}
        >
          <Box>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                textAlign: "center",
                mb: 6,
              }}
            >
              <Box
                sx={{
                  flex: 1,
                  borderBottom: "2px solid",
                  borderColor: "white",
                }}
              />
              <Typography
                body="h2"
                className="welcome-title-text"
                sx={{
                  fontSize: { xs: "0.8rem", sm: "1.7rem" },
                  mx: 2,
                  whiteSpace: "nowrap",
                  color: "white",
                  letterSpacing: 5,
                }}
              >
                WELCOME TO DURHAM PLUMERIA
              </Typography>
              <Box
                sx={{
                  flex: 1,
                  borderBottom: "2px solid",
                  borderColor: "white",
                }}
              />
            </Box>
            <Typography
              variant="h2"
              component="h1"
              className="felipa-texts"
              sx={{
                fontWeight: "bold",
                fontSize: isMobile ? "4rem" : "4.5rem",

                color: "#ffffff",
                fontFamily: '"Apple Chancery", Sans-serif',
                mb: 4,
                textShadow: "0 2px 5px rgba(0,0,0,0.4)",
                letterSpacing: 5,
              }}
            >
              Fine Handcrafted Plumeria
            </Typography>
            <Box
              variant="contained"
              sx={{
                px: 6,
                py: 2,
                backgroundColor: "#31B44B",
                color: "white",
                width: "20%",
                borderRadius: 0,
                fontWeight: "bold",
                fontSize: "1.1rem",
                "&:hover": {
                  backgroundColor: "#232323",
                },
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                margin: "auto",
                boxShadow: "0 4px 15px rgba(0, 0, 0, 0.2)", // <- add this line
                cursor: "pointer", // optional: make it feel clickable
                transition: "all 0.3s ease", // smooth shadow transition
                whiteSpace: "nowrap",
              }}
            >
              <Typography className="dmsans-texts" letterSpacing={2}>
                SHOP NOW
              </Typography>
              <PlayArrowIcon />
            </Box>
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default HeroSection;
